import { render } from "./ComparePlayers.vue?vue&type=template&id=595006c3&scoped=true"
import script from "./ComparePlayers.vue?vue&type=script&lang=js"
export * from "./ComparePlayers.vue?vue&type=script&lang=js"

import "./ComparePlayers.vue?vue&type=style&index=0&id=595006c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595006c3"]])

export default __exports__